export const handleChangeDataOrdersPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_ORDERS', name, value
});